/**
 * Shared helpers for mapping `/cypher/read` rows into Settings list models
 * (flagged nodes, low confidence, review queue).
 */

/** Non-empty string, trimmed; undefined otherwise. */
export function asString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : undefined
}

export function asLabels(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((l): l is string => typeof l === 'string') : []
}

/** Shared node identity fields returned by the Settings list Cypher queries. */
export interface CypherNodeIdentity {
  id: string
  labels: string[]
  name?: string
  path?: string
}

/**
 * Map id / labels / name / path from a node Cypher row. Null when there is
 * no usable business or element id.
 */
export function mapCypherNodeIdentity(row: Record<string, unknown>): CypherNodeIdentity | null {
  const id = asString(row.id) ?? asString(row.element_id)
  if (id === undefined) return null

  const identity: CypherNodeIdentity = { id, labels: asLabels(row.labels) }
  const name = asString(row.name)
  if (name !== undefined) identity.name = name
  const path = asString(row.tag_path) ?? asString(row.folder_name)
  if (path !== undefined) identity.path = path
  return identity
}
